const Constants = {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  TOGGLE_SIDEBAR_DESKTOP: "TOGGLE_SIDEBAR_DESKTOP",
  CHANGED_SIDEBAR: "CHANGED_SIDEBAR"
};
export default Constants;
